export default __webpack_public_path__ + "media/images/features/ja/right_orn-bc1b99a6f216dbd5ca042d12a0205f33.png";